import { useEffect } from 'react';
import { useAuthStore } from '../context/AuthContext';
import { AolSectionDataUpdateDto } from '../types/Dto/AolSectionDataUpdateDto';
import { useAolUpdateHandler } from '../app/useAolUpdateHandler';
import useApi from './useApi';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import useApiEndpoints from '../context/useApiEndpoints';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';
import useSyncOfflineData from 'src/utils/connectivity/useSyncOfflineData';
import useGetAolData from './aol/useGetAolData';
import { formatAolUrlDate } from 'src/utils/aol/aolDateUtils';
import { useAolStore } from 'src/context/AolContext';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { signalRConnectionId } = useAuthStore();
    const { processApiEndpointError } = apiEndpointUtils();
    const { updateAolStatusToUpdater } = useAolUpdateHandler();
    const { state, postApiData } = useApi();
    const { syncItemsIfHasOfflineNoonReports } = useSyncOfflineData();
    const { getAolData } = useGetAolData();
    const { aolFilter } = useAolStore();

    useEffect(() => {
        if (state.status === 'success') {
            if (state.endpoint === apiEndpoints['updateSectionStatus'].url) {
                updateAolStatusToUpdater(state.additionalInfo.aolSectionDataUpdate);
            }
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    const updateSectionStatus = async (aolSectionDataUpdate: AolSectionDataUpdateDto) => {
        const noonReportId = await syncItemsIfHasOfflineNoonReports(aolSectionDataUpdate.noonReportId);
        let callGetAolData = false;
        if (aolSectionDataUpdate.noonReportId !== noonReportId) {
            callGetAolData = true;
            aolSectionDataUpdate.noonReportId = noonReportId;
        }
        await postApiData({
            endpoint: apiEndpoints['updateSectionStatus'].url,
            data: aolSectionDataUpdate,
            queryParam: buildQueryParams({
                imoNumber: aolSectionDataUpdate.imoNumber,
                connectionId: signalRConnectionId,
                noonReportId,
            }),
            additionalInfo: { aolSectionDataUpdate, additionalLoaderData: { section: aolSectionDataUpdate.noonReportSectionEnum } },
        });

        if (callGetAolData) {
            await getAolData(aolSectionDataUpdate.imoNumber, formatAolUrlDate(aolFilter.fromDate), formatAolUrlDate(aolFilter.toDate), true);
        }
    };

    return {
        updateSectionStatus,
    };
};
